export var Step = /*#__PURE__*/ function(Step) {
    Step["First"] = "first";
    Step["SavingFirstStep"] = "savingFirstStep";
    Step["Second"] = "second";
    Step["QBO"] = "qbo";
    Step["QBOSetup"] = "qboSetup";
    Step["Saving"] = "Saving";
    return Step;
}({});
